export default "__VITE_ASSET__1cc018b3__"